/* Shared native SVGs from the existing navigation icon set. */
export const Icon = ({ d, size = 16, sw = 1.8, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"
       aria-hidden={props['aria-label'] ? undefined : true} {...props}>{d}</svg>
);
export const RefreshIcon = props => <Icon {...props} d={<>
  <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
</>}/>;
export const PaperclipIcon = props => <Icon {...props} d={
  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
}/>;
